import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Combobox, ComboboxItem } from '@node-space/ui-components'
import { RewardsProduct } from 'types/rewards'

interface RewardsCryptoSelectProps {
  rewardsProducts: RewardsProduct[]
  currency: string
  onChange: (value: string) => void
}

export const RewardsCryptoSelect = ({
  rewardsProducts,
  currency,
  onChange,
}: RewardsCryptoSelectProps) => {
  const { t } = useTranslation()

  const currencyOptions = useMemo<ComboboxItem[]>(() => {
    return rewardsProducts.map(product => ({
      value: product.currency,
      leftText: product.currency,
      LeftElement: <Avatar name={product.currency} size="small" />,
    }))
  }, [rewardsProducts])

  return (
    <Combobox
      id="currency"
      label={t('currency')}
      selectPlaceholder={t('select')}
      items={currencyOptions}
      defaultValue={currency}
      onChange={onChange}
    />
  )
}
